export default __webpack_public_path__ + "static/media/dg_banner.ce78403a.png";